import React from "react";
import { TextField, InputAdornment, Tooltip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const SearchInput = ({
  value,
  onChange,
  label,
  disabled = false,
  tooltipTitle = "",
  sx = {},
  ...props
}) => {
  return (
    <Tooltip title={tooltipTitle} placement="top" arrow>
      <TextField
        variant="outlined"
        size="small"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        label={label}
        disabled={disabled}
        sx={{
          "& .MuiOutlinedInput-root": { borderRadius: "16px" },
          ...sx,
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        {...props}
      />
    </Tooltip>
  );
};

export default SearchInput;
